import { c as _c } from "react/compiler-runtime";
import { FormInput, Modal, ModalSizeEnum, PrimaryButton, SecondaryButton } from '@systemeio/ui';
import { FormEvent, useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { defaultErrors, defaultHeaderValues } from './constants/default-values';
import { useEditHandler } from './hooks/use-edit-handler';
import { AddIcon } from '@systemeio/ui/icons';
export const AddHeaderModal = t0 => {
  const $ = _c(41);
  const {
    id,
    initialText,
    opened,
    setOpened
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const initialTextData = initialText || defaultHeaderValues.text;
  const [text, setText] = useState(initialTextData);
  const {
    errors,
    isFetching,
    handleEdit,
    setErrors
  } = useEditHandler();
  const isEdit = id !== undefined;
  let t1;
  if ($[0] !== isEdit || $[1] !== t) {
    t1 = isEdit ? t("dashboard.store.edit_section.title") : t("dashboard.store.add_section.title");
    $[0] = isEdit;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const title = t1;
  let t2;
  if ($[3] !== isEdit || $[4] !== t) {
    t2 = isEdit ? t("dashboard.store.edit_section.button_title") : t("dashboard.store.add_section.button_title");
    $[3] = isEdit;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const buttonTitle = t2;
  let t3;
  let t4;
  if ($[6] !== initialText || $[7] !== isEdit) {
    t3 = () => {
      if (isEdit && initialText) {
        setText(initialText);
      }
    };
    t4 = [initialText, isEdit];
    $[6] = initialText;
    $[7] = isEdit;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== setOpened) {
    t5 = () => {
      setOpened(false);
    };
    $[10] = setOpened;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const close = t5;
  let t6;
  if ($[12] !== initialTextData || $[13] !== setErrors) {
    t6 = () => {
      setErrors(defaultErrors);
      setText(initialTextData);
    };
    $[12] = initialTextData;
    $[13] = setErrors;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const afterLeave = t6;
  let t7;
  if ($[15] !== close || $[16] !== handleEdit || $[17] !== id || $[18] !== text) {
    t7 = async e => {
      e.preventDefault();
      try {
        await handleEdit({
          data: {
            text
          },
          id
        });
        close();
      } catch {}
    };
    $[15] = close;
    $[16] = handleEdit;
    $[17] = id;
    $[18] = text;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const onSubmit = t7;
  let t8;
  if ($[20] !== t) {
    t8 = t("dashboard.store.header.label");
    $[20] = t;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e_0 => setText(e_0.target.value);
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== errors.text || $[24] !== t8 || $[25] !== text) {
    t10 = <FormInput autoFocus={true} className="w-full" key="header" label={t8} value={text} onChange={t9} error={errors.text} />;
    $[23] = errors.text;
    $[24] = t8;
    $[25] = text;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== buttonTitle || $[28] !== isFetching) {
    t11 = <PrimaryButton type="submit" isFetching={isFetching}>{buttonTitle}</PrimaryButton>;
    $[27] = buttonTitle;
    $[28] = isFetching;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== onSubmit || $[31] !== t10 || $[32] !== t11) {
    t12 = <form className="flex flex-col items-center gap-8" onSubmit={onSubmit}>{t10}{t11}</form>;
    $[30] = onSubmit;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== afterLeave || $[35] !== close || $[36] !== isFetching || $[37] !== opened || $[38] !== t12 || $[39] !== title) {
    t13 = <Modal title={title} opened={opened} onClose={close} size={ModalSizeEnum.small} isCentered={true} isFetching={isFetching} afterLeave={afterLeave}>{t12}</Modal>;
    $[34] = afterLeave;
    $[35] = close;
    $[36] = isFetching;
    $[37] = opened;
    $[38] = t12;
    $[39] = title;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  return t13;
};
const AddHeader = () => {
  const $ = _c(11);
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setOpened(true);
    t1 = <AddIcon className="group-focus-visible:fill-background-secondary group-hover:fill-background-secondary main-transition-colors fill-text-primary" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.store.add_section.button_title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <SecondaryButton onClick={t0}>{t1}<b>{t2}</b></SecondaryButton>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== opened) {
    t4 = <AddHeaderModal opened={opened} setOpened={setOpened} />;
    $[6] = opened;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default AddHeader;